import { Component, OnInit, Input, EventEmitter, Renderer2, SimpleChanges, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { RecSearchService } from '../../rec-search-service';
import { InstrumentVM, RecDocVM } from '../../../shared/viewmodels/ISearchService';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
//import { ImageViewerComponent } from '../../../shared/components/ng2-image-viewer';
//import { ImageViewerComponent} from 'ng2-image-viewer';
import { RecDocDetailParentComponent } from '../../components/rec-doc-detail-parent/rec-doc-detail-parent.component';

@Component({
  selector: 'app-rec-bp-doc-disp-pg',
  providers: [RecSearchService],
  templateUrl: './rec-bp-doc-disp-pg.component.html',
  styleUrls: ['./rec-bp-doc-disp-pg.component.css']
})
export class RecBpDocDispPgComponent implements OnInit, OnDestroy {

  public docId: number = 0;
  public book: string;
  public page: string;
  public source: string;
  collapsesideinfo: boolean = false;
  public record: RecDocVM;
  error: any;
  public isImgVwVisible: boolean = true;
  public isLoadingDetail: boolean = true;
  @ViewChild(RecDocDetailParentComponent, { static: false }) recDocDetailParentChild;
  screenWidth: any;
  public searchType: string;


  constructor(private route: ActivatedRoute,
    private service: RecSearchService,
    private router: Router, private renderer: Renderer2, public nav: NavMenuService) {
    this.book = this.route.snapshot.paramMap.get('book');
    this.page = this.route.snapshot.paramMap.get('page');
    this.source = this.route.snapshot.paramMap.get('source');
    this.nav.hide();
  }

  /** Initialize image viewer */
  ngOnInit() {
    //console.log('ngOnInit() fired');
    console.log('Calling loadImageByBookPage() from ngOnInit ');

    if (+this.book > 246)
      //search plans too
      this.searchType = "all";
    else
      this.searchType = "deeds";

    this.isLoadingDetail = true;
    this.searchDocument(this.book, this.page);
  }

  toggleSideInfo() {
    this.collapsesideinfo = !this.collapsesideinfo;
 
  }

  loadRef(e: InstrumentVM) {
    console.log(`loadRef fired: ${e}`);
    console.log(`loadRef fired: ${e.docID}`);
    this.isLoadingDetail = true;
    this.docId = e.docID;
    this.book = e.primaryID;
    this.page = e.secondaryID;
    this.recDocDetailParentChild.loadRef(e);
    this.isLoadingDetail = false;
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  getIsImgVwVisible(e) {
    this.isImgVwVisible = e;
  }

  loadInfo(e: RecDocVM) {
    this.record = e;
  }

  /**
   * Navigate to previous page.
   * @param url
   */
  back(url) {

    if (this.source == '1') {
      window.opener = 'Self';
      window.open('', '_parent', '');
      window.close();
    }
    else {
      this.router.navigate([url]);
      this.nav.show();
    }
  }



  /**
   * Search document for a book and page number entered by the user.
   * @param sBook
   * @param sPage
   */
  searchDocument(sBook: string, sPage: string) {

    console.log('recbpdocdisppg - ' + this.searchType )
    this.isLoadingDetail = true;

    //if (this.source == '2') {
    //  localStorage.removeItem("machineId");
    //  localStorage.removeItem("machineLocation");
    //  localStorage.setItem("machineLocation", '2');
    //}

    this.service.getContainingDoc(sBook, sPage, this.searchType).subscribe(
      data => {
        console.log('containdoc ' + data.docID);
        this.docId = data.docID;
        this.book = data.primaryID;
        this.page = data.secondaryID;

        this.service.getRecDoc(this.docId).subscribe(
          data => {
            this.record = data;
            this.isLoadingDetail = false;
          },
          error => { this.error = error }
        );

      },
      error => { this.error = error }
    );
  }


  ngOnDestroy() {
    this.nav.show();
  }

}
